import React from "react";
import { BankForm } from "./Forms/BankForm";
import { useCreateBankMutation } from "../../services/basicData/basicData";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Container, Form, Spinner } from "reactstrap";
import { Stack } from "react-bootstrap";

export const CreateBank = () => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: {
      name_ar: "",
      name_en: "",
    },
  });

  const { mutate: createBank, isPending } = useCreateBankMutation(setError);
  const { t } = useTranslation();

  const onSubmit = (data) => {
    createBank(data);
  };

  return (
    <Stack gap={2}>
      <PageHeader title={t("CREATE_BANK")}  />
      <Container fluid>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <BankForm control={control} errors={errors} />
          <Button variant="primary" type="submit" disabled={isPending}>
            {isPending ? (
              <>
                <Spinner size="sm" />
                {t("CREATING_BANK")}
              </>
            ) : (
              t("CREATE_BANK")
            )}
          </Button>
        </Form>
      </Container>
    </Stack>
  );
};
